module.exports = __webpack_public_path__ + "ad0eecb43b07c3ab77b2b1ad632e5cb1.svg";